<div class="d-flex align-items-center w-100">
	<ng-container *ngFor="let value of values">
		<div [style.width.%]="value.percent" [tooltip]="value.name" [ngClass]="value.class" [style.height.px]="height"></div>
	</ng-container>

	<div class="text-nowrap chart-label small" [class.ms-2]="total && total != '0'">
		{{ total }}
	</div>
</div>
